import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import './LanguageToggle.css';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="language-toggle-group">
      <button
        className={`language-toggle ${language === 'tr' ? 'language-toggle--active' : ''}`}
        onClick={() => setLanguage('tr')}
        aria-label="Türkçe"
        title="Türkçe"
      >
        TR
      </button>
      <button
        className={`language-toggle ${language === 'en' ? 'language-toggle--active' : ''}`}
        onClick={() => setLanguage('en')}
        aria-label="English"
        title="English"
      >
        EN
      </button>
      <button
        className={`language-toggle ${language === 'it' ? 'language-toggle--active' : ''}`}
        onClick={() => setLanguage('it')}
        aria-label="Italiano"
        title="Italiano"
      >
        IT
      </button>
      <button
        className={`language-toggle ${language === 'ru' ? 'language-toggle--active' : ''}`}
        onClick={() => setLanguage('ru')}
        aria-label="Русский"
        title="Русский"
      >
        RU
      </button>
    </div>
  );
};

export default LanguageToggle;